import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  text: "The best massage experience I've had in Singapore. The platform made it so easy to find a reputable place near my office.",
  author: 'Sarah Tan',
  role: 'Marketing Executive',
  service: 'Aromatherapy at Serenity Spa',
  rating: 5
}, {
  text: '非常棒的推荐！通过这个平台找到的中式推拿师傅手法非常专业，多年的肩颈痛得到了缓解。',
  author: 'Michael Chen',
  role: 'Software Engineer',
  service: 'TCM at Golden Hands',
  rating: 5
}, {
  text: "I love the verified reviews feature. It gives me peace of mind knowing I'm booking a safe and quality service.",
  author: 'Jessica Lim',
  role: 'Teacher',
  service: 'Foot Reflexology at Happy Feet',
  rating: 4
}];
export function TestimonialsSection() {
  return <section id="reviews" className="py-24 bg-white" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        <div className="text-center mb-16" data-id="element-268">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-forest mb-4" data-id="element-269">
            What Our Users Say{' '}
            <span className="text-gold font-light" data-id="element-270">用户评价</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-271">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream/30 p-8 rounded-2xl border-l-4 border-gold relative hover:bg-cream/60 transition-colors duration-300" data-id="element-272">
              <Quote className="absolute top-6 right-6 text-gold/20" size={40} data-id="element-273" />

              <div className="flex gap-1 mb-6" data-id="element-274">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className={`${i < item.rating ? 'fill-gold text-gold' : 'text-stone/20'}`} data-id="element-275" />)}
              </div>

              <p className="text-stone/80 italic mb-6 leading-relaxed min-h-[80px]" data-id="element-276">
                "{item.text}"
              </p>

              <div className="flex items-center gap-4" data-id="element-277">
                <div className="w-10 h-10 rounded-full bg-stone/10 flex items-center justify-center text-stone font-bold font-serif" data-id="element-278">
                  {item.author.charAt(0)}
                </div>
                <div data-id="element-279">
                  <h4 className="font-bold text-forest text-sm" data-id="element-280">
                    {item.author}
                  </h4>
                  <p className="text-xs text-stone/50" data-id="element-281">{item.service}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}